import { render } from "./ChoicesCombinationsContainer.vue?vue&type=template&id=68df14b8&scoped=true"
import script from "./ChoicesCombinationsContainer.vue?vue&type=script&lang=js"
export * from "./ChoicesCombinationsContainer.vue?vue&type=script&lang=js"

import "./ChoicesCombinationsContainer.vue?vue&type=style&index=0&id=68df14b8&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68df14b8"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QField});
